import {
  mapState,
  mapMutations
} from 'vuex'
import api from '../service/services'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
const {
  detect
} = require('detect-browser')
const browser = detect()

export default {
  name: 'imagesPreview',
  data () {
    return {
      data: [],
      isLoading: false,
      data_bill: [],
      data_images: [],
      count_images: 0,
      total_images: 0,
      zipfile: [],
      error_massage: '',
      current_page: 0,
      items_perpage: 1,
      result_count: 0,
      screenHeight: window.innerHeight - 220,
      current_path: '',
      url_path: ''
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapState(['url', 'os']),
    ...mapMutations(['setUser']),
    paginate: function () {
      this.result_count = this.data_images.length
      if (this.current_page >= this.totalPages) {
        this.current_page = Math.max(0, this.totalPages - 1)
      }
      var index = this.current_page * this.items_perpage
      return this.data_images.slice(index, index + this.items_perpage)
    },
    totalPages: function () {
      return Math.ceil(this.result_count / this.items_perpage)
    }
  },
  methods: {
    getBill (key) {
      this.isLoading = true
      var obj = {
        bill_key: key
      }
      api.AXbill(
        this.url,
        obj,
        result => {
          if (result.status === 1) {
            this.data = result.data
            this.data_bill = result.data.bill
            this.count_images = this.data_bill.cnt_upload
            this.total_images = this.data_bill.total_upload
            result.data.images.forEach(val => {
              this.data_images.push({
                // src: 'https://photogenius.sgp1.digitaloceanspaces.com/' + this.data_bill.bill_number + '/' + this.data_bill.bill_folder + '/' + val['image_name'],
                // src: 'https://photogenius.sgp1.digitaloceanspaces.com/' + this.data_bill.bill_number + '/' + this.data_bill.bill_folder + '/' + val['image_name'],
                src: '../../PGws/PGDownload/' + this.data_bill.bill_number + '/' + this.data_bill.bill_folder + '/' + val['image_name'],
                path: '../../PGws/PGDownload/' + this.data_bill.bill_number + '/' + this.data_bill.bill_folder + '/' + val['image_name'],
                name: val['image_name'],
                id: val['id']
              })
            })
            var checkId = this.data_images.map(function (e) {
              return e.id
            }).indexOf(this.$route.params.id)

            if (checkId <= this.data_images.length) {
              if (checkId >= 0 && checkId <= this.data_images.length) {
                this.setPage(checkId)
                this.isLoading = false
              } else {
                this.$router.push({
                  name: 'ImagePreview',
                  params: {
                    key: this.$route.params.key,
                    id: this.data_images.length
                  }
                })
              }
            }
          } else {
            this.isLoading = false
            alert('error ' + JSON.stringify(result))
            this.error_massage = result.data
          }
        },
        error => {
          this.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    downloadAll () {
      swal({
        title: 'Do you want to download all the photos?',
        text: 'Images are compressed into zip files for download. It may take about 2 minutes.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Download Now'
      }).then((result) => {
        if (result.value) {
          this.isLoading = true
          var obj = []
          this.data_images.forEach(val => {
            obj.push({
              id: val['id']
            })
          })

          obj = {
            bill_key: this.$route.params.key,
            image_ids: obj
          }
          console.log(JSON.stringify(obj))

          api.AXzipfile(this.url, obj,
            result => {
              this.isLoading = false
              if (result.status === 1) {
                console.log(result.data)
                window.location = result.data.zipfile
                console.clear()
              } else {
                alert(JSON.stringify(result.data))
              }
              this.checkbox_data = []
              this.selected = false
            },
            error => {
              this.isLoading = false
              alert(JSON.stringify(error))
            })
        }
      })
    },
    setPage (pageNumber) {
      this.current_page = pageNumber
      this.current_path = this.paginate[0].path
      this.url_path = this.paginate[0].src
    }
  },
  mounted () {
    this.getBill(this.$route.params.key)
    this.$store.state.os = browser.os
    try {
      this.setUser()
    } catch (e) {
      // location.reload()
    }
    setInterval(function () {
      this.screenHeight = window.innerHeight - 200
    }.bind(this), 100)
  }
}



// WEBPACK FOOTER //
// ./src/js/image_preview.js